<template>
  <div class="Left-container" style="height: 100%;">
    <el-menu :default-openeds="openList" class="el-menuClass" style="overflow-y: auto"
             background-color="rgb(48,65,86)"
             text-color="white"
             active-text-color="yellow"
             :collapse-transition="false"
             :collapse="fff_left_collapseFlag"
             router><!--router是开启菜单的路由！！！！！！！！！！！！！！！！！！！！！！！！！！！！！-->

      <!--左侧头部LOGO-->
      <div style="height: 60px;line-height: 60px;text-align: center">
        <img style="width: 20px;position: relative;top:5px;margin-right: 5px;"
             src="../../css_assets/logo.png"/>
        <b style="color: white" v-show="fff_left_logoTextShowFlag">人工智能系统</b>
      </div>
      <div v-for="item in menuList" :key="item.id">
        <!--有path一级菜单，全靠login Controller返回的父子关系数据-->
        <div v-if="item.path">
          <el-menu-item :index="item.path">
            <i :class="item.icon"></i><!--这里如果不放在上面，收缩时会看不到-->
            <template slot="title">
              <span>{{ item.name }}</span>
            </template>
          </el-menu-item>
        </div>
        <!--二级菜单-->
        <div v-else>
          <el-submenu :index="item.id+''">
            <template slot="title">
              <i :class="item.icon"></i>
              <span v-show="fff_left_logoTextShowFlag">{{ item.name }}</span>
            </template>
            <div v-for="subItem in item.children" :key="subItem.id">
              <el-menu-item :index="subItem.path">
                <i :class="subItem.icon"></i>
                <span>{{ subItem.name }}</span>
              </el-menu-item>
            </div>
          </el-submenu>
        </div>
      </div>

      <!--固定写法成为过去！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！-->
      <!--  <el-menu-item index="/home">
            <i class="el-icon-house"></i>&lt;!&ndash;这里如果不放在上面，收缩时会看不到&ndash;&gt;
            <template slot="title">
                <span>主页</span>
            </template>
        </el-menu-item>
        &lt;!&ndash;第二个&ndash;&gt;
        <el-submenu index="2">
            <template slot="title">
                <i class="el-icon-menu"></i>
                <span>系统管理</span>
            </template>

            &lt;!&ndash;二级菜单&ndash;&gt;
            <el-menu-item index="/user">
                <template slot="title">
                    <i class="el-icon-s-custom"></i>
                    <span>用户管理</span>
                </template>
            </el-menu-item>
            <el-menu-item index="/role">
                <template slot="title">
                    <i class="el-icon-s-check"></i>
                    <span>角色管理</span>
                </template>
            </el-menu-item>
            <el-menu-item index="/menu">
                <template slot="title">
                    <i class="el-icon-film"></i>
                    <span>菜单管理</span>
                </template>
            </el-menu-item>
            <el-menu-item index="/document">
                <template slot="title">
                    <i class="el-icon-notebook-1"></i>
                    <span>文件管理</span>
                </template>
            </el-menu-item>
        </el-submenu>-->
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "Left",
  props: ['fff_left_collapseFlag', 'fff_left_logoTextShowFlag'], // 接受父组件传递的值
  data() {
    // 读取后端返回的菜单列表
    let menuList = localStorage.getItem("menuList") ? JSON.parse(localStorage.getItem("menuList")) : [];
    // 前端注入"统一管理"菜单（FTP 文件管理：操作员/任务/提示音/任务数据）
    menuList.push({
      id: 'admin-menu',
      name: '统一管理',
      icon: 'el-icon-s-tools',
      children: [
        {id: 'admin-user', path: '/admin/user', name: '操作员管理', icon: 'el-icon-user'},
        {id: 'admin-task', path: '/admin/task', name: '任务管理', icon: 'el-icon-tickets'},
        {id: 'admin-sound', path: '/admin/sound', name: '提示音管理', icon: 'el-icon-bell'},
        {id: 'admin-data', path: '/admin/data', name: '任务数据', icon: 'el-icon-folder-opened'}
      ]
    });
    return {
      menuList,
      openList: menuList.map(item => item.id + '')
    }
  },
  created() {
    //alert(JSON.stringify(this.openList))
    // alert(JSON.stringify(this.menuList))
  },
  methods: {}
}
</script>

<style scoped lang="less">

</style>
